import {NgModule} from '@angular/core';
import {FunctieOverzichtPageComponent} from './functie-overzicht-page.component';
import {MaterialModule} from '../../../app.material.module';
import {CommonModule} from '@angular/common';
import {SearchModule} from '../../../components/search/search.module';
import {FunctieModule} from '../../../components/functie/functie.module';
import {RouterModule, Routes} from '@angular/router';
import {CompareModule} from '../../../components/compare/compare.module';
import {InterestSelectorModule} from '../../../components/interest/interest-selector/interest-selector.module';
import {FormsModule} from '@angular/forms';
import {ContentModule} from '../../../services/content/content.module';
import {FilterModule} from '../../../components/filter/filter.module';

const routes: Routes = [
  {
    path: '',
    component: FunctieOverzichtPageComponent
  }
];

@NgModule({
    declarations: [FunctieOverzichtPageComponent],
    imports: [
        MaterialModule,
        CommonModule,
        SearchModule,
        FunctieModule,
        RouterModule.forChild(routes),
        CompareModule,
        InterestSelectorModule,
        FormsModule,
        ContentModule,
        FilterModule
    ],
    exports: [FunctieOverzichtPageComponent]
})
export class FunctieOverzichtPageModule {}
